import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db, auth } from '../../../config/firebase';

/**
 * Creates an initial book entry in Firestore with basic information
 * @param {Object} bookData - Initial book data
 * @returns {Promise<string>} - The ID of the created book
 */
export async function createInitialBook(bookData) {
  try {
    const userId = auth.currentUser?.uid;
    if (!userId) {
      throw new Error('You must be logged in to create books');
    }

    console.log('Creating initial book with data', {
      userId,
      title: bookData.title,
      totalPages: bookData.totalPages,
      wordsPerPage: bookData.wordsPerPage
    });

    // Create the basic book document with initial data
    const bookRef = await addDoc(collection(db, 'books'), {
      title: bookData.title || 'Untitled Story',
      totalPages: parseInt(bookData.totalPages, 10) || 32,
      pageSize: bookData.pageSize || 'us-trade',
      wordsPerPage: parseInt(bookData.wordsPerPage, 10) || 50,
      storyContent: bookData.storyContent || '',
      bookStyle: bookData.bookStyle || null,
      visualStyle: bookData.visualStyle || null,
      writingStyle: bookData.writingStyle || null,
      userId,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      status: 'draft',
      hasPageNumbers: true,
      // Add default cover colors
      frontCoverColor: '#8585ff',
      backCoverColor: '#8585ff',
      coverDetails: {
        frontCover: {
          color: '#8585ff',
          lastUpdated: Timestamp.now(),
        },
        backCover: {
          color: '#8585ff',
          lastUpdated: Timestamp.now(),
        },
      },
    });

    console.log('Initial book created with ID', bookRef.id);
    return bookRef.id;
  } catch (error) {
    console.error('Error creating initial book:', error);
    throw error;
  }
}
